var React = require('react');

function LongArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M319.91 292H24a24 24 0 0 1-24-24v-24a24 24 0 0 1 24-24h295.91l35.66 36z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M305.44 103.05L441 238.54l.06.06a25.23 25.23 0 0 1 0 34.84l-.06.06L305.44 409a24 24 0 0 1-33.94 0l-17-17a24 24 0 0 1 0-33.94L355.57 256 254.5 154a24 24 0 0 1 0-33.94l17-17a24 24 0 0 1 33.94-.01z","className":"fa-primary","key":2})]);
}

LongArrowRight.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = LongArrowRight;

LongArrowRight.default = LongArrowRight;
